import Vue from 'vue'
import VueRouter from 'vue-router'
// import Cookies from 'js-cookie'
// import store from '../store'

Vue.use(VueRouter)
export const dynamicRoutes = [
  // 可视化
  {
    path: '/visualization',
    name: 'visualization',
    component: () =>
      import(/* webpackChunkName: "visualization" */ '../views/visualization/visualization.vue'),
    meta: {
      showHeader: false
    }
  }
]
const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/start-page'
  },
  {
    path: '/start-page',
    name: 'start-page',
    component: () =>
      import(/* webpackChunkName: "start-page" */ '../views/start-page/start-page.vue'),
    meta: {
      keepAlive: true,
      showHeader: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
// 框架处理完毕会执行回调
router.afterInitMenus = store => {
  // console.log(store.getters['core/menus'])
  dynamicRoutes.forEach(r => {
    router.addRoute(r)
  })
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// router.beforeEach((to, from, next) => {
//   const token = Cookies.get('__8081__TOKEN')
//   console.log(token)
//   if (token) {
//     if (to.path === '/page/data-query' || to.path === '/page/comparison-analysis') {
//       store.dispatch('getBreedType')
//       store.dispatch('getBreedWay')
//     }
//   }
//   next()
// })

export default router
